import { createContext, useContext, useEffect, useState, useCallback } from "react";

// PATCH 36/37 — manual dark/light theme. Dark is the platform default and the ONLY thing shown
// unless a user explicitly chooses light; we no longer follow the OS (that regressed dark mode for
// anyone on a light-themed OS). Any legacy "system" value is migrated to dark on load.
const KEY = "kadana_theme";
const ThemeCtx = createContext(null);

function readChoice() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" ? "light" : "dark"; // "system"/null/anything else -> dark
  } catch {
    return "dark";
  }
}

function apply(choice) {
  const resolved = choice === "light" ? "light" : "dark";
  document.documentElement.setAttribute("data-theme", resolved);
  return resolved;
}

export function ThemeProvider({ children }) {
  const [choice, setChoice] = useState(readChoice);
  const [resolved, setResolved] = useState("dark");

  useEffect(() => {
    setResolved(apply(choice));
    try { localStorage.setItem(KEY, choice); } catch { /* ignore */ }
  }, [choice]);

  const toggle = useCallback(() => setChoice((c) => (c === "dark" ? "light" : "dark")), []);

  return <ThemeCtx.Provider value={{ choice, resolved, setChoice, toggle }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx) || { choice: "dark", resolved: "dark", setChoice: () => {}, toggle: () => {} };
